import axios from 'axios';
import config from '../../../config';

const TERMINAL_ID = 'e734b9dcc7b63868f36169035f73b58a';
const SEVENT_DESKTOP_ID = '7ab88f3109a0e898fb6151a58376dad6';

const languageMapper = {
  'sr-latn': 'sr',
  'mk-latn': 'mk',
};

const http = axios.create({
  baseURL: config.API.tc[config.env],
  timeout: 10000,
});

const getUrl = (projectId, language, companyUuid) => {
  const mappedLanguage = languageMapper[language.toLowerCase()] || language;

  const projectsLocale = `/translations/${projectId}/locales/${mappedLanguage}`;
  const tenantLocale = companyUuid ? `${projectsLocale}/tenants/${companyUuid}` : projectsLocale;

  return `${tenantLocale}?includeLocaleFallback=true`;
};

export default {
  getAll({ storeDispatch, company }) {
    const terminalTranslationsUrl = getUrl(TERMINAL_ID, company.locale, company.uuid);
    const sevenDesktopTranslationsUrl = getUrl(SEVENT_DESKTOP_ID, company.locale, company.uuid);

    axios.all([
      http.get(terminalTranslationsUrl),
      http.get(sevenDesktopTranslationsUrl),
    ]).then((res) => {
      const translations = _.merge({}, res[0].data, res[1].data);
      storeDispatch('updateTranslations', translations);
    }).catch();
  },
};
